/**
 * @name getUserAgent
 * @description Returns the current User Agent string, or an empty string when there is no window,
 * i.e. during server-side rendering.
 */
const getUserAgent = (): string =>
  typeof window === "undefined" ? "" : window.navigator.userAgent;

export default getUserAgent;
